<template>
  <div class="main-body">
    <div class="desktop-order-options" style="clear: both; margin-top: 15px;">
      <div class="">
          <el-button :class="getClassListForOrderStatus('all')" @click="fetchOrdersForButtons()">All</el-button>
          <el-button :class="getClassListForOrderStatus('status$open')" @click="fetchOrdersForButtons(null, null, 'status', 'open')">Open</el-button>
          <el-button :class="getClassListForOrderStatus('status$processed')" @click="fetchOrdersForButtons(null, null, 'status', 'processed')">Processed</el-button>
          <el-button :class="getClassListForOrderStatus('status$delivered')" @click="fetchOrdersForButtons(null, null, 'status', 'delivered')">Delivered</el-button>
          <el-button :class="getClassListForOrderStatus('financial_status$pending')" @click="fetchOrdersForButtons(null, null, 'financial_status', 'pending')">Payment Pending</el-button>
          <el-button :class="getClassListForOrderStatus('financial_status$failed')" @click="fetchOrdersForButtons(null, null, 'financial_status', 'failed')">Payment Failed</el-button>
          <el-button :class="getClassListForOrderStatus('financial_status$failed')" @click="fetchOrdersForButtons(null, null, 'financial_status', 'cancelled')">Payment Cancelled</el-button>
          <el-button :class="getClassListForOrderStatus('financial_status$paid')" @click="fetchOrdersForButtons(null, null, 'financial_status', 'paid')">Payment Done</el-button>
          <el-button :class="getClassListForOrderStatus('status$cancelled')" @click="fetchOrdersForButtons(null, null, 'status', 'cancelled')">Cancelled</el-button>
      </div>
    </div>
    <div class="mobile-order-options" style="margin-top: 15px;">
      <el-select v-model="ss" @change="filterOrdersBySelectMenu(ss)">
        <el-option value="all" label="All">All</el-option>
        <el-option value="status$open" label="Open">Open</el-option>
        <el-option value="status$processed" label="Processed">Processed</el-option>
        <el-option value="status$delivered" label="Delivered">Delivered</el-option>
        <el-option value="financial_status$pending" label="Payment Pending">Payment Pending</el-option>
        <el-option value="financial_status$failed" label="Payment Failed">Payment Failed</el-option>
        <el-option value="financial_status$cancelled" label="Payment Cancelled">Payment Cancelled</el-option>
        <el-option value="financial_status$paid" label="Payment Done">Payment Done</el-option>
        <el-option value="status$cancelled" label="Cancelled">Cancelled</el-option>
      </el-select>
    </div>

    <el-scrollbar class="customer-details-scroll" style="margin-top: 20px;">
      <div class="">
        <el-table
          v-loading="mainLoading"
          class="table"
          :lazy="mainLoading"
          :data="orders"
          style="width: 100%; text-align: left; ">
          <el-table-column
            label="Order Id"
            prop="auto_id">
            <template slot-scope="{ row }">
              <el-link :href="getItemUrl(row.auto_id)" >{{ row.auto_id }}</el-link>
            </template>
          </el-table-column>
          <el-table-column
            label="City"
          >
            <template slot-scope="{ row }">
              {{ row.shipping_address.city }}
            </template>
          </el-table-column>
          <el-table-column
            label="Payment Status"
            prop="financial_status">
            <template slot-scope="{ row }">
              <el-tag v-if="row.financial_status === 'paid'" type="success">Paid</el-tag>
              <el-tag v-else-if="row.financial_status === 'pending'" type="warning">Pending</el-tag>
              <el-tag v-else-if="row.financial_status === 'failed'" type="danger">Failed</el-tag>
              <el-tag v-else type="info">{{ row.financial_status }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column
            label="Order Status"
            prop="status">
            <template slot-scope="{ row }">
              <el-tag v-if="row.status === 'open'" type="" effect="dark">Open</el-tag>
              <el-tag v-else-if="row.status === 'processed'" type="warning" effect="dark">Processed</el-tag>
              <el-tag v-else-if="row.status === 'cancelled'" type="danger">Cancelled</el-tag>
              <el-tag v-else-if="row.status === 'delivered'" type="success" effect="dark">Delivered</el-tag>
              <el-tag v-else type="info">{{ row.status }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column
            label="Delivery Date"
            prop="delivery_date">
            <template slot-scope="{ row }">
              {{ orderDeliveryDate(row) }}
            </template>
          </el-table-column>
          <el-table-column
            label="Order Date"
            prop="created_at">
            <template slot-scope="{ row }">
              {{ orderDate(row.created_at) }}
            </template>
          </el-table-column>
          <el-table-column
            label="Price"
            prop="total_price">
          </el-table-column>
        </el-table>
      </div>
      <div style="margin-top: 20px; text-align: center;">
        <el-pagination
          @current-change="handlePageChange"
          @size-change="handlePageSizeChange"
          :current-page.sync="page"
          :page-sizes="[30, 40 ,50]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalOrdersCount">
        </el-pagination>
      </div>
    </el-scrollbar>
  </div>
</template>

<script>
import { $adminAxios } from '../config/axios'
import priceMixin from '../mixins/priceMixin'
import moment from 'moment'

export default {
  name: 'Categories',
  mixins: [
    priceMixin,
  ],
  data: function () {
    return {
      defaultTableProps: {
        size: "mini",
        border: true,
      },
      columns: [{
        prop: 'auto_id',
        label: 'Order Id',
        required: true,
      }],
      orders: [],
      totalOrdersCount: 0,
      mainLoading: true,
      page: 1,
      pageSize: 30,
      activeStatusFilter: 'all',
      ss: 'all',
    }
  },
  computed: {
    computedTableProps() {
      return {
        ...this.defaultTableProps,
        ...(this.tableProps || {}),
      };
    },
    orderDate() {
      return (date) => {
        return moment(date).format('MMM DD, yy hh:mm A')
      }
    },
    orderDeliveryDate() {
      return order => {
        const deliveryDateInDiffFormat = order.delivery_date_string && order.delivery_date_string.split('-').reverse().join('-')
        return `${deliveryDateInDiffFormat}, (${order.delivery_time_slot})`
      }
    },
  },
  mounted() {
    this.fetchOrders()
  },
  methods: {
    filterOrdersBySelectMenu(type) {
      console.log('sddd', type)
      if (type === "all") {
        this.fetchOrdersForButtons()
      } else if (type === "status$open" ) {
        this.fetchOrdersForButtons(null, null, 'status', 'open')
      } else if (type === "status$processed" ) {
        this.fetchOrdersForButtons(null, null, 'status', 'processed')
      } else if (type === "status$delivered" ) {
        this.fetchOrdersForButtons(null, null, 'status', 'delivered')
      } else if (type === "financial_status$pending" ) {
        this.fetchOrdersForButtons(null, null, 'financial_status', 'pending')
      } else if (type === "financial_status$failed" ) {
        this.fetchOrdersForButtons(null, null, 'financial_status', 'failed')
      } else if (type === "financial_status$cancelled" ) {
        this.fetchOrdersForButtons(null, null, 'financial_status', 'cancelled')
      } else if (type === "financial_status$paid" ) {
        this.fetchOrdersForButtons(null, null, 'financial_status', 'paid')
      } else if (type === "status$cancelled" ) {
        this.fetchOrdersForButtons(null, null, 'status', 'cancelled')
      }
    },
    getItemUrl(id) {
      return `/admin/orders/${id}`
    },
    async fetchOrders (page, limit, statusType, statusValue) {
      page = page || this.page
      limit = limit || this.pageSize

      this.mainLoading = true

      try {
        const response = await $adminAxios.get(`/orders?page=${page}&limit=${limit}&status[]=paid&statusType=${statusType}&statusValue=${statusValue}`)
        this.orders = response.data.data
        this.totalOrdersCount = response.data.total
      } catch (err) {
        console.error(err)
        this.$notify.success({
          title: 'Error',
          message: err.message || 'Something went wrong',
          type: 'error'
        });
      }

      this.mainLoading = false
    },
    getRowValue(object, columnObject) {
      const path = columnObject.prop;
      const type = columnObject.type;

      const value =
        typeof this.$lodash.result(object, path) === "undefined"
          ? "--"
          : this.$lodash.result(object, path);

      if (type === "date") {
        const valueTemp =
          value && value !== "--"
? {
              type: "string",
              value: moment.utc(new Date(value)).format('yyyy-mm-dd'),
            }
: { type: "string", value: "--" };
        return valueTemp;
      }
      if (Array.isArray(value)) {
        return { type: "array", value };
      }
      return { type: "string", value };
    },
    handlePageChange(page) {
      this.fetchOrders(page, this.size)
    },
    handlePageSizeChange(size) {
      this.fetchOrders(this.page, size)
    },
    fetchOrdersForButtons(page, limit, statusType, statusValue) {
      this.activeStatusFilter = statusType && statusValue ? `${statusType}$${statusValue}` : 'all'
      this.fetchOrders(page, limit, statusType, statusValue)
    },
    getClassListForOrderStatus(type) {
      const classList = ['b-active']

      if (this.activeStatusFilter === type) {
        return classList
      } if (this.activeStatusFilter === type) {
        return classList
      } else if (this.activeStatusFilter === type) {
        return classList
      } else if (this.activeStatusFilter === type) {
        return classList
      } else if (this.activeStatusFilter === type) {
        return classList
      } else if (this.activeStatusFilter === type) {
        return classList
      } else if (this.activeStatusFilter === type) {
        return classList
      } else if (this.activeStatusFilter === type) {
        return classList
      }

      return []
    },
  },
}
</script>

<style lang="scss" scoped>
.customer-details-scroll {
  position: relative;
  height: calc(100vh - 150px);
  margin-top: 10px;
}
</style>

<style lang="scss" scoped>
.b-active {
  color: #409eff;
  border-color: #c6e2ff;
  background-color: #ecf5ff;
}
.mobile-order-options {
  display: none;
}
.desktop-order-options {
  display: block;
}

@media screen and (max-width:768px) {
  .mobile-order-options {
    display: block;
  }
  .desktop-order-options {
    display: none;
  }
}
</style>
